import { fetchGetters } from '@/store/extensions/fetch';
import { createGetters } from '@/store/extensions/create';
import { updateGetters } from '@/store/extensions/update';
import { deleteGetters } from '@/store/extensions/delete';

export default {
  ...fetchGetters,
  ...createGetters,
  ...updateGetters,
  ...deleteGetters,

  context: state => state.context,
  processing: state => state.processing,
  accepting: state => state.accepting,
};



// WEBPACK FOOTER //
// ./src/store/modules/policy/getters.js